import React, { createContext, useContext, useState, useEffect } from 'react';
import { superAdminApi } from '../services/api';

const SuperAdminAuthContext = createContext(null);

const TOKEN_KEY = 'cafe_super_token';
const USER_KEY  = 'cafe_super_user';

export const SuperAdminAuthProvider = ({ children }) => {
  const [superAdmin, setSuperAdmin] = useState(null);
  const [loading, setLoading]       = useState(true);

  useEffect(() => {
    const token  = localStorage.getItem(TOKEN_KEY);
    const stored = localStorage.getItem(USER_KEY);
    if (token && stored) {
      try { setSuperAdmin(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await superAdminApi.login({ email, password });
    const { token, admin } = res.data.data;
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(admin));
    setSuperAdmin(admin);
    return admin;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setSuperAdmin(null);
    window.location.href = '/super-admin/login';
  };

  return (
    <SuperAdminAuthContext.Provider value={{ superAdmin, login, logout, loading, isAuthenticated: !!superAdmin }}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
};

export const useSuperAdminAuth = () => {
  const ctx = useContext(SuperAdminAuthContext);
  if (!ctx) throw new Error('useSuperAdminAuth must be used within SuperAdminAuthProvider');
  return ctx;
};
